const routes = {
    "main": "/",
    "register": "/register",
    "reset": "/reset",
    "changePassword": '/changePassword',
    "profile": '/profile',
    "confirmOTP": '/confirmOTP',
    "createAdmin": '/createAdmin',
    "addSchool": '/addSchool',
    "editSchool": '/editSchool',
    "addNewRules": '/addNewRules',
    "pricing": '/pricing',
    "subscription":'/subscription',
    "timeTable":"/timeTable",    
    'ownerInvite': '/ownerInvite/:id',
    'publicTimeTable': '/timeTableView/:timeTableId/:typeId',
    "whySchoolPivot": "/whySchoolPivot",
    'howItWorks': '/howItWorks',
    'orderHistory': '/orderHistory',
}

export default routes;